<template>
  <error v-if="error" :error="error" />    
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('settings.Breed_info') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
              <div class="input-group input-group-static null">
              <label>{{ $t('settings.Code') }} *</label>
              <input v-model="state.code" type="text" class="form-control form-control-default" :placeholder="$t('settings.Code')">
              <span v-if="v$.code.$error" class="text-sm text-danger">
                  {{ v$.code.$errors[0].$message }}
              </span>
              </div>
          </div>
          <div class="col-6">
              <div class="input-group input-group-static null">
              <label>{{ $t('settings.Name') }} *</label>
              <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('settings.Name')">
              <span v-if="v$.name.$error" class="text-sm text-danger">
                  {{ v$.name.$errors[0].$message }}
              </span>
              </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6" v-if="['Admin'].includes(userRoleName)">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.Association') }} *</label>  
              <select id="associationId" v-model="state.associationId" class="form-control form-control-default">
                  <option value="">{{ $t('settings.Select_association') }}</option>         
                  <option v-for="association in state.associations" :key="association.id" :value="association.id">                  
                      {{ association.abbreviation }}
                  </option>                  
              </select>        
              <span v-if="v$.associationId.$error" class="text-sm text-danger">
                  {{ v$.associationId.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.RVO_recognized') }}</label>
                <div class="d-block mt-1">
                <material-switch v-model="state.rvoRecognized" id="rvoRecognized" name="rvoRecognized" />
                </div>
            </div>
          </div>
        </div>      
        <div class="col-12 col-sm-12 mt-6">                                
          <input type="hidden" v-model="state.id" class="form-control">          
          <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
          <button v-on:click="updateBreed" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>
        </div>        
      </div>
    </div>    
  </template>
  
  <script>
  import * as Choices from "choices.js";
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  
  export default {
    name: "BreedDetail",
    setup() {
        const { t } = useI18n()
        const store = useStore()

        const state = reactive ({            
            breed: [],            
            id: '',
            name: '',
            code: '',
            associationId: '',
            rvoRecognized: false,
            associations:[],
        })

        const userRoleName = computed(() => store.state.user?.roleName)
        
        const rules = computed(() => {
            const isAdmin = userRoleName.value === 'Admin';

            return {
                name: { required: helpers.withMessage(t('common.Required'), required) },
                code: { required: helpers.withMessage(t('common.Required'), required) },
                associationId: isAdmin
                ? {
                    required: helpers.withMessage(t('common.Required'), required),
                    isSelected: helpers.withMessage(t('common.Select_an_association'), value => value !== '')
                }
                : {}
            }
        })
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$,
            userRoleName,
            choicesInstance: null // Store Choices instance
        }
    },    
    components: {
      MaterialSwitch      
    },
    data() {
      return {        
        gets: [],
        error: '',        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;            
      await this.fetchBreedData(this.$route.params.id);         
    },
    methods: { 
      async fetchAllAssociationData() {
          try {             
              const response = await axios.get("Association/getall");
              const result = response.data;

              if (result.success && Array.isArray(result.data.associationList)) {
                  this.state.associations = result.data.associationList;

                  this.$nextTick(() => {
                      this.initializeChoices();
                  });                    
              } else {
                this.$showError('errors.Error_fetching_association');                  
              }
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },      
      initializeChoices() {
          const element = document.getElementById("associationId");
          if (this.choicesInstance) {
              this.choicesInstance.destroy(); // Clean up previous instance
          }

          this.choicesInstance = new Choices(element, {
              searchEnabled: true,
              shouldSort: false,
              placeholder: true, 
              //placeholderValue: '-- Select association --', 
          });

          // Set the dropdown options
          if (Array.isArray(this.state.associations) && this.state.associations.length > 0) {
              // Check if the registerId exists among the registers
              if (this.state.associationId) {
                  const optionExists = this.state.associations.some(x => x.id === this.state.associationId);
                  if (optionExists) {
                      this.choicesInstance.setChoiceByValue([this.state.associationId]); // Set the selected value
                  } else {
                      this.choicesInstance.setChoiceByValue(''); // Clear if no match found
                  }
              }
          }

          // Listen for changes and update state
          element.addEventListener('change', (event) => {
              this.state.registerId = event.target.value; // Update the state
              this.v$.$validate(); // Trigger validation
          });
      },

      async fetchBreedData(breedId) {
        try {            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Breed/${breedId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.breed = this.gets.data;
                this.state.id = this.state.breed.id;
                this.state.name = this.state.breed.name;
                this.state.associationId = this.state.breed.associationId;
                this.state.code = this.state.breed.code;
                this.state.rvoRecognized = this.state.breed.rvoRecognized;

                if (this.userRoleName === 'Admin') {
                    await this.fetchAllAssociationData();
                }
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },
      async updateBreed() {   
            try {
                this.$store.commit('setShowLoading', true);

                this.v$.$validate();
                console.log(this.v$.$error);

                if(!this.v$.$error) {

                    const formData = {
                        "id": this.state.id,
                        name: this.state.name,
                        code: this.state.code,
                        associationId: this.userRoleName === 'Admin'
                            ? this.state.associationId
                            : this.$store.state.associationAdminAssociationId,
                        rvoRecognized: this.state.rvoRecognized
                    };
                    const response = await axios.put('Breed/update', formData);
                    this.gets = response.data;

                    if (this.gets.success) {
                      this.$showSuccess('errors.Success_breed_updated_successfully');
                      this.$router.push('/settings');
                    } else {
                        this.$showError('errors.Contact_system_admin');
                    }
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }                        
            this.$store.commit('setShowLoading', false);
      },
    }
  };
</script>  
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>